<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-gfz">
    <main class="tpl-gfz__main">
      <div v-if="showHero" class="tpl-gfz__hero">
        <img v-if="quiz.logo" :src="quiz.logo" alt="" class="tpl-gfz__hero-img" />
        <h1 class="tpl-gfz__hero-title">{{ quiz.title }}</h1>
        <p v-if="quiz.sub_title" class="tpl-gfz__hero-sub">{{ quiz.sub_title }}</p>
      </div>

      <div class="tpl-gfz__progress">
        <div class="tpl-gfz__progress-track">
          <div
            class="tpl-gfz__progress-fill"
            :style="{
              width: (isGate ? 100 : (progress.current / Math.max(progress.total + 1, 1)) * 100) + '%',
            }"
          ></div>
        </div>
        <span class="tpl-gfz__progress-label">
          ({{ isGate ? progress.total : progress.current }}/{{ progress.total }})
        </span>
      </div>

      <slot />

      <footer class="tpl-gfz__footer">
        <p class="tpl-gfz__footer-links">
          <a v-if="quiz.privacy_url" :href="quiz.privacy_url" target="_blank">
            {{ quiz.privacy_text || 'Privacy Policy' }}
          </a>
        </p>
        <p v-if="quiz.legal_name" class="tpl-gfz__footer-legal">
          {{ quiz.legal_name }}<template v-if="quiz.legal_id"> — {{ quiz.legal_id }}</template>
        </p>
        <p v-if="quiz.disclaimer" class="tpl-gfz__footer-disclaimer">{{ quiz.disclaimer }}</p>
      </footer>
    </main>
  </div>
</template>
